import script from "./RolFormListView.vue?vue&type=script&setup=true&lang=js"
export * from "./RolFormListView.vue?vue&type=script&setup=true&lang=js"

import "./RolFormListView.vue?vue&type=style&index=0&id=73890b77&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73890b77"]])

export default __exports__